import { render, staticRenderFns } from "./contact.vue?vue&type=template&id=1fc6fe3e"
import script from "./contact.vue?vue&type=script&lang=js"
export * from "./contact.vue?vue&type=script&lang=js"
import style0 from "./contact.vue?vue&type=style&index=0&id=1fc6fe3e&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IdContactAddressInfo: require('/workspace/components/contact/AddressInfo.vue').default,IdFaqTop: require('/workspace/components/faq/Top.vue').default,IdContactForm: require('/workspace/components/ContactForm.vue').default,IdContactSocialLinks: require('/workspace/components/contact/SocialLinks.vue').default,IdContactFaq: require('/workspace/components/contact/Faq.vue').default,IdContactTerms: require('/workspace/components/contact/Terms.vue').default})
